import React from 'react';
import useStyles from './styles';
import { Checkbox, InputLabel } from '@material-ui/core';

export default function Bool({ field, onChange, errors = {}, small, value }) {
	const classes = useStyles();
	let iserror = errors[field.name] ? true : null;

	return (
		<div className={classes.wrapper}>
			<InputLabel>{field.label}{field.required === 'true' ? " *" : ''}</InputLabel>
			<Checkbox
				id={field.name}
				name={field.name}
				error={iserror}
				variant="outlined"
				size={small ? 'small' : 'medium'}
				// value={value}
				color="default"
				checked={Boolean(value)}
				onChange={(e) => onChange(e.target.checked)}
				helpertext={errors[field.name] ? errors[field.name] : null}
			/>
		</div>
	);
}
